import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useAuth } from '../context/AuthContext';
import ConfirmModal from './ConfirmModal';
import '../styles/header.css';

export default function HeaderNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const items = [
    { to: '/', label: 'Dashboard', icon: 'pi pi-th-large', end: true },
    { to: '/schedule', label: "Today's Schedule", icon: 'pi pi-calendar' },
    { to: '/orders', label: 'Orders', icon: 'pi pi-shopping-bag' },
    // { to: '/orders-history', label: 'Orders History', icon: 'pi pi-clock' },
    { to: '/trucks', label: 'Trucks', icon: 'pi pi-truck' },
    { to: '/drivers', label: 'Drivers', icon: 'pi pi-users' },
    { to: '/reports', label: 'Reports & Analytics', icon: 'pi pi-chart-line' }
  ];

  const handleLogout = () => setShowConfirm(true);
  const confirmLogout = () => { setShowConfirm(false); logout(); navigate('/login', { replace: true }); };

  return (
    <>
      <header className="header-bar">
        {/* <div className="brand" onClick={() => navigate('/')}>🚚 ConcreteFlow</div> */}
        <nav className="nav">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => classNames('nav-link', { active: isActive })}
            >
              <i className={classNames(item.icon)} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="right">
          <Button label="Settings" icon="pi pi-cog" className="p-button-outlined settings-btn" onClick={() => navigate('/settings')} />
          <div className="user" title={user?.email || ''}>
            <i className="pi pi-user" />
          </div>
          <Button label="Logout" icon="pi pi-sign-out" className="p-button-text logout-btn" onClick={handleLogout} />
        </div>
      </header>

      <ConfirmModal
        show={showConfirm}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        onConfirm={confirmLogout}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
}